import React, { useState, useRef } from 'react';
import { useSources } from 'hooks';
import { IconButton } from '@material-ui/core';
import { MdDownload } from 'react-icons/md';
import { CSVLink } from 'react-csv';
import _ from 'lodash';

import { formatDate } from 'utils/time';
import API from 'utils/api';

import { Table, Tooltip } from 'components';

const InfluencerWaitList = props => {
  const [dataReport, setDataReport] = useState([]);
  const [csvLink, setCsvLink] = useState();
  const tableRef = useRef();

  const sources = useSources();

  const { dateFrom, dateTo } = props;

  const columns = [
    {
      title: 'User',
      field: 'name',
      render: rowData => {
        let name = 'Anonymous user';

        if (rowData.type === 'waitlist') {
          const waitListStaus = _.get(rowData, 'waitlist.status', null);
          const phone = _.get(rowData, 'waitlist.phoneNumber', null);
          name = waitListStaus === 'confirmed' ? phone : null;
        }

        if (rowData.name) {
          name = rowData.name;
        }

        return <div>{name}</div>;
      },
    },
    {
      title: 'Referral from',
      field: 'waitlist.referralCode',
    },
    {
      title: 'Engagement',
      field: 'engagement',
    },
    {
      title: 'Subscribed',
      field: 'createdAt',
      render: rowData => <div>{formatDate(rowData.createdAt)}</div>,
      type: 'date',
    },
  ];

  const renderControlPanel = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton onClick={exportCSV}>
          <Tooltip title="Click to export table data" placement="top">
            <MdDownload />
          </Tooltip>
        </IconButton>
      </div>
    );
  };

  const exportCSV = () => {
    let query = {};

    const search = _.get(tableRef, 'current.state.search', '');

    if (search.length > 0) {
      query.name = search;
    }

    API.getUserInteractions(
      {
        ...query,
        type: 'waitlist',
      },
      sources
    ).then(({ data }) => {
      if (data && data.docs) {
        const users = data.docs.map(user => {
          let name = 'Anonymous user';

          if (user.type === 'waitlist') {
            const waitListStatus = _.get(user, 'waitlist.status', null);
            const phone = _.get(user, 'waitlist.phoneNumber', null);
            name = waitListStatus === 'confirmed' ? phone : null;
          }

          if (user.name) {
            name = user.name;
          }

          return {
            user: name,
            referral: user.waitlist.referralCode,
            engagement: user.engagement,
            subscribed: user.createdAt,
          };
        });
        setDataReport(users);
        csvLink.link.click();
      }
    });
  };

  const fetchData = ({ pageSize, page, search, sort }) => {
    let query = {};

    if (search && search.length > 0) {
      query.name = search;
    }

    return API.getUserInteractions(
      {
        type: 'waitlist',
        ...query,
        per_page: pageSize,
        page,
        from: dateFrom,
        to: dateTo,
        sort: sort ? sort : 'createdAt',
      },
      sources
    );
  };

  return (
    <>
      <CSVLink
        data={dataReport}
        filename="data.csv"
        className="hidden"
        ref={r => setCsvLink(r)}
        target="_blank"
      />

      <Table
        title="Users"
        columns={columns}
        data={fetchData}
        tableRef={tableRef}
        controlPanel={renderControlPanel()}
      />
    </>
  );
};

export default InfluencerWaitList;
